import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchProject } from "../../store/project/projectAction";
import { fetchProducts } from "../../store/products/productsAction";
import { fetchBanners } from "../../store/banners/bannersAction";
import { fetchBrands } from "../../store/brands/brandsAction";
//import { Link } from "react-router-dom";

import Banner from "./banner";
import Brand from "./brand";
import Products from "./products";
import Outtime from "../outtime/outtime";
import Notfound from "../outtime/notfound";


import { config } from "../../constants";
//const Cryptr = require("cryptr");
//const cryptr = new Cryptr(config.appkey);

import axios from 'axios';

const fpe = require("node-fpe");
const cipher = fpe({ password: config.appkey });

// import CallApi from "../../util/CallApi";

// const callApi = new CallApi();

class IndexPage extends Component {
  // componentWillMount() {
  //   const test_d = cipher.encrypt("20190613141453415406208"); // 75425843464693649658750
  //   console.log(test_d);
  //   //'4185730'
  //   console.log(cipher.decrypt(test_d));
  // }
  state = {
    pageNotfound: false
  };

  async componentDidMount() {

    let resp = await axios.post(config.apiUrl + "/login/gtkn", {});

    // if (parseInt(resp.data.code) === 200) {
    //   localStorage.setItem('sys_token', resp.data.token);
    // }

    // const gtknResp = await callApi.setSysToken();
    // console.log(gtknResp)
    // if (parseInt(gtknResp.code) === 200) {
    //   localStorage.setItem('sys_token', gtknResp.token);
    // }

    // const {
    //   match: { params }
    // } = this.props;
    const {
      match: { params }
    } = this.props;
    localStorage.setItem("project_id", params.project);

    try {
      // const projectId = cryptr.decrypt(params.project);
      // const paramsApi = { project_id: projectId };
      // this.props.fetchProject(paramsApi);
      const projectId = cipher.decrypt(params.project);
      //console.log(projectId);
      const paramsApi = { project_id: projectId };
      // console.log('fpj 02');
      this.props.fetchProject(paramsApi);
      this.props.fetchProducts({ project_id: projectId });
      this.props.fetchBrands({ project_id: projectId });
      this.props.fetchBanners({ project_id: projectId });
    } catch (error) {
      this.setState({ pageNotfound: true });
      console.log(error);
    }
  }

  render() {
    //const cipher = fpe({ password: config.appkey });
    //const test_d = cipher.encrypt("20190613141453415406208");
    //console.log(test_d);
    // '4185730'

    //console.log(cipher.decrypt(test_d));
    // '1234567'
    if (this.state.pageNotfound) {
      return <Notfound>ไม่พบหน้านี้</Notfound>;
    }
    if (this.props.projectNotfound) {
      return <Notfound>ไม่พบแคมเปญนี้</Notfound>;
    }

    if (this.props.project.hasOwnProperty("project_id")) {
      //console.log(this.props.project.project_id);
      const {
        match: { params }
      } = this.props;
      localStorage.setItem("project_id", params.project);
    }
    const projectStatus = this.props.project.project_status;
    //console.log(projectStatus);
    if (!projectStatus) {
      return <></>;
    } else if (projectStatus !== "A") {
      //return <Redirect to="/outtime" />;
      return (
        <>
          <Outtime />
        </>
      );
    }

    //if (this.props.project.project_id) {
    // const encryptedString = cryptr.encrypt("20190613141453415406208");
    // const decryptedString = cryptr.decrypt(encryptedString);

    // console.log(encryptedString); // 03e3a86d7de48dfa1b2f2522c38a8bc34b7ef33aa44e // wpo001
    // // 003e046e197646f5cae82a8ffe7f2f71baca17a294a82e6f5725c165a7f579a3df699a53b1a02c // 20190613141453415406208
    // console.log(decryptedString); // wpo001
    //}

    return (
      <>
        <Banner />
        {/* <Link to="/register">register</Link> */}
        <div className="container marketing_mobile">
          <div className="row">
            <Brand />
            <Products />
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  project: state.project.info,
  isFetching: state.project.isFetching,
  projectNotfound: state.project.projectNotfound
});

export default connect(
  mapStateToProps,
  {
    fetchProject,
    fetchProducts,
    fetchBanners,
    fetchBrands
  }
)(IndexPage);
